import { Component } from '@angular/core';
import { StoreService } from '@app/shared/services/store.service';
import { theme } from '../../../data/theme';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
    theme = theme;

    constructor(public store: StoreService) { }
}
